/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiHotelGetHotelRoomInfoPost } from '../fn/get-hotel-room-info-endpoint/api-hotel-get-hotel-room-info-post';
import { ApiHotelGetHotelRoomInfoPost$Params } from '../fn/get-hotel-room-info-endpoint/api-hotel-get-hotel-room-info-post';
import { HotelRoomsResponseResultApiResult } from '../models/hotel-rooms-response-result-api-result';

@Injectable({ providedIn: 'root' })
export class GetHotelRoomInfoEndpointService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiHotelGetHotelRoomInfoPost()` */
  static readonly ApiHotelGetHotelRoomInfoPostPath = '/api/hotel/GetHotelRoomInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelGetHotelRoomInfoPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelGetHotelRoomInfoPost$Response(params: ApiHotelGetHotelRoomInfoPost$Params, context?: HttpContext): Observable<StrictHttpResponse<HotelRoomsResponseResultApiResult>> {
    return apiHotelGetHotelRoomInfoPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelGetHotelRoomInfoPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelGetHotelRoomInfoPost(params: ApiHotelGetHotelRoomInfoPost$Params, context?: HttpContext): Observable<HotelRoomsResponseResultApiResult> {
    return this.apiHotelGetHotelRoomInfoPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<HotelRoomsResponseResultApiResult>): HotelRoomsResponseResultApiResult => r.body)
    );
  }

}
